export let notes = [
    {
        title: "If dough is too sticky",
        text: "If your fingers are sticking to the dough, you can just lightly grease them with some olive oil."
    },
    {
        title: "Special pan",
        text: "A lot of Detroit-Style Pizzas are made in a special pan. I didn’t buy a special pan but I do think that a dark-colored 9x13-inch baking pan works better than a lighter colored. I linked to a dark 9x13-inch pan. Glass baking dishes *WILL NOT* work for this recipe. They don't conduct enough heat fast enough and hot enough to cook the crust properly."
    },
    {
        title: "Cheese",
        text: "I used cubed aged provolone that I found at my local Italian market, but if you can’t find, no worries, just replace it with more mozzarella, or experiment with other kinds of cheeses."
    },
    {
        title: "Pepperoni",
        text: `For pepperoni cups, you want pepperoni that's sliced on the thicker side. My friend Billy suggests the pepperoni from the 365 Whole Foods Brand. For this recipe, I used the <a href="https://hormel.com/Brands/Pepperoni/Pizza-Party/HORMEL-Pepperoni-Cup-N-Crisp" target="_blank">Hormel Pepperoni Cups</a>. I found them at my local grocery store. I thought they were wonderful.`
    },
    {
        title: "Pizza Sauce",
        text: "Any kind of pizza sauce, or even some tasty pasta sauce, should work fine."
    }
]